const animationParallaxEffect = (container) => {
  const section = container.querySelector('.parallax-effect');
  const image = section.querySelector('img');

  if (image) {
    gsap.set(image, { yPercent: 80 });

    gsap.to(image, {
      yPercent: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top-=80% center', // the default values
        end: 'bottom+=20% center',
        scrub: 0.3,
        //markers: true,
      },
    });
  }
};

export default animationParallaxEffect;
